import { render, staticRenderFns } from "./export-result.vue?vue&type=template&id=70709495&scoped=true&"
import script from "./export-result.vue?vue&type=script&lang=ts&"
export * from "./export-result.vue?vue&type=script&lang=ts&"
import style0 from "./export-result.vue?vue&type=style&index=0&id=70709495&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70709495",
  null
  
)

export default component.exports